import Notification from "../../../components/Common/Notification/index";
import * as mainOrderApi from "../../../services/mainOrder";
import {
  ADD_MAIN_ORDER_FAILURE,
  ADD_MAIN_ORDER_REQUEST,
  ADD_MAIN_ORDER_SUCCESS,
  DELETE_MAIN_ORDER_FAILURE,
  DELETE_MAIN_ORDER_REQUEST,
  DELETE_MAIN_ORDER_SUCCESS,
  GET_MAIN_ORDERS_FAILURE,
  GET_MAIN_ORDERS_REQUEST,
  GET_MAIN_ORDERS_SUCCESS,
  GET_SINGLE_MAIN_ORDER_FAILURE,
  GET_SINGLE_MAIN_ORDER_REQUEST,
  GET_SINGLE_MAIN_ORDER_SUCCESS,
  UPDATE_MAIN_ORDER_FAILURE,
  UPDATE_MAIN_ORDER_REQUEST,
  UPDATE_MAIN_ORDER_SUCCESS,
} from "./mainOrder.actionType";

export const requestAddMainOrder = () => {
  return {
    type: ADD_MAIN_ORDER_REQUEST,
  };
};

export const addMainOrderSuccess = (data) => {
  return {
    type: ADD_MAIN_ORDER_SUCCESS,
    data,
  };
};

export const addMainOrderFailure = (message) => {
  return {
    type: ADD_MAIN_ORDER_FAILURE,
    message,
  };
};

export const addMainOrder = (data) => {
  return (dispatch) => {
    dispatch(requestAddMainOrder());
    return mainOrderApi
      .addMainOrder(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addMainOrderSuccess(data));
         Notification("", `ऑर्डर नोंद केली`, "success");
         return data
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addMainOrderFailure());
        throw errorMessage;
      });
  };
};

export const requestGetMainOrders = () => {
  return {
    type: GET_MAIN_ORDERS_REQUEST,
  };
};

export const getMainOrdersSuccess = (data) => {
  return {
    type: GET_MAIN_ORDERS_SUCCESS,
    data,
  };
};

export const getMainOrdersFailure = (message) => {
  return {
    type: GET_MAIN_ORDERS_FAILURE,
    message,
  };
};

export const getMainOrders = () => {
  return (dispatch) => {
    dispatch(requestGetMainOrders());
    return mainOrderApi
      .getMainOrders()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getMainOrdersSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getMainOrdersFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSingleMainOrder = () => {
  return {
    type: GET_SINGLE_MAIN_ORDER_REQUEST,
  };
};

export const getSingleMainOrderSuccess = (data) => {
  return {
    type: GET_SINGLE_MAIN_ORDER_SUCCESS,
    data,
  };
};

export const getSingleMainOrderFailure = (message) => {
  return {
    type: GET_SINGLE_MAIN_ORDER_FAILURE,
    message,
  };
};

export const getSingleMainOrder = (id) => {
  return (dispatch) => {
    dispatch(requestgetSingleMainOrder());
    return mainOrderApi
      .getSingleMainOrder(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSingleMainOrderSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSingleMainOrderFailure());
        throw errorMessage;
      });
  };
};

export const requestDeleteMainOrder = () => {
  return {
    type: DELETE_MAIN_ORDER_REQUEST,
  };
};

export const deleteMainOrderSuccess = (data) => {
  return {
    type: DELETE_MAIN_ORDER_SUCCESS,
    data,
  };
};

export const deleteMainOrderFailure = (message) => {
  return {
    type: DELETE_MAIN_ORDER_FAILURE,
    message,
  };
};

export const deleteMainOrder = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteMainOrder());
    return mainOrderApi
      .deleteMainOrder(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deleteMainOrderSuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deleteMainOrderFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdateMainOrder = () => {
  return {
    type: UPDATE_MAIN_ORDER_REQUEST,
  };
};

export const updateMainOrderSuccess = (data) => {
  return {
    type: UPDATE_MAIN_ORDER_SUCCESS,
    data,
  };
};

export const updateMainOrderFailure = (message) => {
  return {
    type: UPDATE_MAIN_ORDER_FAILURE,
    message,
  };
};

export const updateMainOrder = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdateMainOrder());
    return mainOrderApi
      .updateMainOrder(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updateMainOrderSuccess(data));
        Notification("", `ऑर्डर नोंद केली`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updateMainOrderFailure());
        Notification("", errorMessage, "error");
      });
  };
};
